export const preventScrolling = (e) => {
    e.preventDefault()
  };